export default "__VITE_ASSET__DSHSBh8S__"